import {IIncident} from "../../../core/interfaces/incident";
import CustomTextAreaInput from "../../../components/FormComponents/CustomTextAreaInput";
import FormProvider from "./FormProvider/FormProvider";

export function ExternalUsersDescriptionForm(props: { editMode: boolean, newIncident: IIncident, onChange: (e: any) => void }) {
    return (<FormProvider controlId="formExternalUsersDescription"
                          title={'Ytterligare information angående externa personer'} colAs={'large'}>
            <CustomTextAreaInput
                disabled={!props.newIncident.hasExternalUsers}
                isEditMode={props.editMode}
                rows={5}
                name={"externalUsersDescription"}
                testId={'formExternalUsersDescription'}
                value={props.newIncident.externalUsersDescription ?? ''}
                onChange={props.onChange}
            />
        </FormProvider>
    );
}